"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChipArrayInput = void 0;
var react_1 = require("react");
var ChipArrayInput_style_1 = __importDefault(require("../ChipArrayInput/ChipArrayInput.style"));
function useChipArrayInput(_a) {
    var disallowDuplicates = _a.disallowDuplicates, errorText = _a.errorText, validate = _a.validate, setValues = _a.setValues, values = _a.values;
    var classes = (0, ChipArrayInput_style_1.default)();
    var _b = __read((0, react_1.useState)(''), 2), currentInput = _b[0], setCurrentInput = _b[1];
    var _c = __read((0, react_1.useState)(), 2), validationError = _c[0], setValidationError = _c[1];
    var trimmedInput = currentInput.trim();
    var handleAdd = function () {
        if (!trimmedInput.length) {
            return;
        }
        var error = validate === null || validate === void 0 ? void 0 : validate(trimmedInput);
        if (error) {
            setValidationError(error);
            return;
        }
        setValidationError(undefined);
        if (disallowDuplicates && values.some(function (value) { return value.toLowerCase() === trimmedInput.toLowerCase(); })) {
            setCurrentInput('');
            return;
        }
        setValues(__spreadArray(__spreadArray([], __read(values), false), [trimmedInput], false));
        setCurrentInput('');
    };
    var onDeleteChip = function (removedIndex) {
        setValues(values.filter(function (_, index) { return index !== removedIndex; }));
    };
    var onChange = function (event) {
        setValidationError(undefined);
        setCurrentInput(event.target.value);
    };
    var onKeyDown = function (event) { return event.key === 'Enter' && handleAdd(); };
    return {
        classes: classes,
        currentInput: currentInput,
        adaptedErrorText: validationError || errorText,
        handleAdd: handleAdd,
        onDeleteChip: onDeleteChip,
        onChange: onChange,
        onKeyDown: onKeyDown,
        trimmedInput: trimmedInput,
    };
}
exports.useChipArrayInput = useChipArrayInput;
